module.exports = __webpack_public_path__ + "img/geo-zones-1-mobile.f5b61523.gif";